import { StatusBar, StatusBarStyle } from 'expo-status-bar'
import { observer } from 'mobx-react-lite'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import {
  ActivityIndicator,
  Image,
  Keyboard,
  KeyboardAvoidingView,
  Platform,
  SafeAreaView,
  StyleSheet,
  TextInput,
  TouchableOpacity,
  View
} from 'react-native'

import { ActionModal, Text } from '../../components'
import { translate } from '../../i18n'
import { useStore } from '../../models'
import { fontFamily } from '../../theme'
import { startStyles } from './styles'
import { useRouter } from 'expo-router'

export const LiveEventNameScreen = observer(() => {
  const router = useRouter()
  const inputRef = useRef(null)
  const store = useStore()

  const [userName, setUserName] = useState(store.session.user ? store.session.user.name : '')
  const [isVisible, setIsVisible] = React.useState(false)
  const [loading, setLoading] = React.useState(false)
  const [isNextActive, setIsNext] = useState(false)

  useEffect(() => {
    if (store.session.user) {
      const playerName = store.session.user.name
      setUserName(playerName)
      setIsNext(true)
    }
  }, [store.session.user])

  const onBack = () => {
    setIsVisible(true)
  }

  const Header = () => {
    return (
      <View style={startStyles.header}>
        <TouchableOpacity style={{ position: 'absolute', left: 24 }} onPress={onBack}>
          <Image
            style={{ height: 24, width: 24 }}
            source={require('../../../assets/userInfo/back.png')}
            resizeMode="contain"
          />
        </TouchableOpacity>
      </View>
    )
  }

  const navToAuth = useCallback(() => {
    if (store.session) {
      store.session.logout()
    }
  }, [store.session])

  const createAccount = async () => {
    Keyboard.dismiss()
    try {
      setLoading(true)
      if (userName) {
        await store.session.updateName(userName)
        const payload = {
          isUserNew: true,
          questionAnswers: [],
          isUserFromLiveEvent: true
        }
        await store.session.updateUserInfo(payload)
        await store.session.fetchMe()
        if (store.session.user?.email && store.session.user?.email !== '') {
          store.analytics.setUserIdentify(store.session.user._id, {
            name: userName,
            email: store.session.user?.email
          })
        }
        setLoading(false)
        router.navigate('/onboarding/real-time-updates')
      }
    } catch (error) {
      setLoading(false)
      console.log('Username API Error: ', error)
    }
  }

  return (
    <KeyboardAvoidingView
      behavior={Platform.OS === 'ios' ? 'padding' : 'height'}
      keyboardVerticalOffset={Platform.OS === 'ios' ? 0 : 50}
      style={{ flex: 1 }}
    >
      <SafeAreaView style={[startStyles.startContainer, { backgroundColor: '#F6F2E9' }]}>
        <StatusBar animated={true} style={'dark' as StatusBarStyle} hidden={false} />
        <Header />
        <View style={startStyles.slide}>
          <Text style={startStyles.question}>{translate('liveEventScreen.pokerNameQuestion')}</Text>
          <Text style={styles.subtitle}>{translate('liveEventScreen.pokerNamesubtitle')}</Text>
          <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
            <Text tx="memberForm.name" style={startStyles.title} />
            <Text style={styles.nameLength}>{userName?.length}/15</Text>
          </View>
          <TextInput
            ref={inputRef}
            placeholder="Enter a name"
            placeholderTextColor={'#68706D'}
            style={startStyles.inputField}
            allowFontScaling={false}
            autoCapitalize={'words'}
            autoCorrect={false}
            maxLength={15}
            autoComplete="off"
            value={userName || ''}
            onChangeText={(value: string) => {
              if (value === '') {
                setIsNext(false)
              } else {
                setIsNext(true)
              }
              setUserName(value)
            }}
            autoFocus={true}
          />
        </View>
        <View style={{ paddingHorizontal: 24 }}>
          <TouchableOpacity
            disabled={!isNextActive}
            onPress={createAccount}
            style={[startStyles.buttonStyle, { opacity: isNextActive ? 1 : 0.5 }]}
          >
            <View style={startStyles.buttonView}>
              <Text style={startStyles.buttonText}>Create Account</Text>
              {loading ? <ActivityIndicator size="small" color="#FFFFFF" style={startStyles.loadingStyle} /> : null}
            </View>
          </TouchableOpacity>
        </View>
        <ActionModal
          key={'logout'}
          onAction={navToAuth}
          onModalHide={() => setIsVisible(false)}
          onClose={() => setIsVisible(false)}
          message={translate('common.logoutConfirmation')}
          visible={isVisible}
        />
      </SafeAreaView>
    </KeyboardAvoidingView>
  )
})

const styles = StyleSheet.create({
  subtitle: {
    marginTop: 5,
    fontFamily: fontFamily.GTAmericaStandardRegular,
    color: '#121212',
    fontSize: 14
  },
  nameLength: {
    marginTop: 32,
    fontWeight: 'bold',
    fontFamily: fontFamily.GTAmericaStandardRegular,
    color: '#68706D',
    fontSize: 14
  }
})
